import Vue from 'vue';

export function getCookie(name)
{
	const value = "; " + document.cookie;
	const parts = value.split("; " + name + "=");
	if (parts.length === 2)
	{
		return unescape(parts.pop().split(";").shift());
	}
}

export function setCookie(name, val, hours)
{
	let now = new Date();
	let time = now.getTime();
	time += hours * 3600 * 1000;
	now.setTime(time);
	
	document.cookie = name + '=' + val + '; expires=' + now.toUTCString() + ';path=/';
}

export function deleteCookie(name)
{
	document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
}

export function populateFormdataWithObject(formData, object, prefix)
{
	prefix = (typeof prefix === 'undefined') ? '' : prefix ;
	const keys = Object.keys(object);
	for(let i = 0; i < keys.length; i++){
		const internalKey = (prefix !== '') ? prefix+'['+keys[i]+']' : keys[i] ;
		if(typeof object[keys[i]] === 'object')
		{
			formData = populateFormdataWithObject(formData,object[keys[i]],internalKey)
		}
		else
		{
			formData.append(internalKey,object[keys[i]])
		}
	}
	return formData;
}

export function setReactiveStateValue(storeObject, property, value)
{
	if (typeof storeObject[property] === 'undefined')
	{
		Vue.set(storeObject, property, value);
	}
	else
	{
		storeObject[property] = value;
	}
}

export function generateRandomString(length)
{
	const characters = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
	const charactersLength = characters.length;
	let randomString = '';
	for (let i = 0; i < length; i++)
	{
		randomString += characters[Math.floor(Math.random() * charactersLength)];
	}
	return randomString;
}

export function removeItemFromArray(arr) {
	let what, a = arguments, L = a.length, ax;
	while (L > 1 && arr.length) {
		what = a[--L];
		while ((ax= arr.indexOf(what)) !== -1) {
			arr.splice(ax, 1);
		}
	}
	return arr;
}

export function escape(s) {
	var pre = document.createElement('pre');
	var text = document.createTextNode( s );
	pre.appendChild(text);
	return pre.innerHTML;
}


export function validateObjectStructure(object, properties)
{
	if (typeof object !== 'object')
	{
		return false;
	}
	
	properties.forEach(property =>
	{
		if (typeof object[property] === 'undefined')
		{
			return false;
		}
	});
	return true;
}


export function isJsonString(str)
{
	try
	{
		JSON.parse(str);
	} catch (e)
	{
		return false;
	}
	return true;
}


export function implode(object, glue, separator)
{
	if (typeof glue === 'undefined')
	{
		glue = '=';
	}
	if (typeof separator === 'undefined')
	{
		separator = ',';
	}
	
	return Object.getOwnPropertyNames(object).map(function (k)
	{
		return [k, object[k]].join(glue);
	}).join(separator);
}

export function isInViewport (elem) {
	const bounding = elem.getBoundingClientRect();
	return (
		bounding.top >= 0 &&
		bounding.left >= 0 &&
		(bounding.bottom-100) <= (window.innerHeight || document.documentElement.clientHeight) &&
		bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
	);
}

export function shuffleArray(array) {
	for (let i = array.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[array[i], array[j]] = [array[j], array[i]];
	}
}
